export const FETCH_TRAINER_APPLIES = 'FETCH_TRAINER_APPLIES';
export const FETCH_TRAINER_APPLY = 'FETCH_TRAINER_APPLY';
export const REJECT_TRAINER_APPLY = 'REJECT_TRAINER_APPLY';
export const APPROVE_TRAINER_APPLY = 'APPROVE_TRAINER_APPLY';



// WEBPACK FOOTER //
// ./src/store/trainer_apply/types.js